var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactIcon, HelpIcon } from '@marketing-icons';
function MoreInfo(_a) {
    var contactRoute = _a.contactRoute, helpRoute = _a.helpRoute;
    return (_jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-4 md:gap-5" }, { children: [_jsx("a", __assign({ href: contactRoute, className: "no-underline", target: "_blank", rel: "noopener noreferrer" }, { children: _jsxs("div", __assign({ className: "flex justify-start items-center gap-3 text-lg-reg-m text-text-body active:text-squash-700 disabled:text-bone-600" }, { children: [_jsx(ContactIcon, {}), _jsx("div", __assign({ className: "" }, { children: "Contact Us" }))] })) })), _jsx("a", __assign({ href: helpRoute, className: "no-underline", target: "_blank", rel: "noopener noreferrer" }, { children: _jsxs("div", __assign({ className: "flex justify-start items-center gap-3 text-lg-reg-m text-text-body active:text-squash-700 disabled:text-bone-600" }, { children: [_jsx(HelpIcon, {}), _jsx("div", __assign({ className: "" }, { children: "Help Center" }))] })) }))] })));
}
export default MoreInfo;
